import { connect } from 'react-redux';

import { getActiveProject, IApplicationState } from '@store';

import Navigation, {
  NavigationStateProps,
} from '../components/navigation/Navigation';

interface IStateToProps
  extends Pick<
    IApplicationState,
    'authentication' | 'error' | 'projectPicker'
  > {}

const mapStateToProps = ({
  authentication,
  error,
  projectPicker,
}: IStateToProps): NavigationStateProps => {
  let activeProject = getActiveProject(projectPicker);
  let defaultTabs = projectPicker.config
    ? projectPicker.config.defaultTabs
    : [];
  return {
    status: authentication.status,
    errors: error.errors,
    tabs:
      activeProject &&
      activeProject.customProperties &&
      activeProject.customProperties.tabs
        ? activeProject.customProperties.tabs
        : defaultTabs,
  };
};

export default connect(mapStateToProps)(Navigation);
